import type Phaser from 'phaser';

let loading: Promise<void> | null = null;

/**
 * Hero select, powerups, the duel, and results. They are not in the first script,
 * so the title can paint before that code arrives.
 */
export function loadPlayScenes(game: Phaser.Game): Promise<void> {
  if (game.scene.getScene('select')) return Promise.resolve();
  if (loading) return loading;
  loading = (async () => {
    const [hero, reveal, power, play, results, hub, road, streak, collection, charms, spin, events, shell, notes] = await Promise.all([
      import('./HeroSelectScene'),
      import('./RivalRevealScene'),
      import('./PowerupSelectScene'),
      import('./GameScene'),
      import('./ResultsScene'),
      import('./HubScene'),
      import('./RoadScene'),
      import('./StreakScene'),
      import('./CollectionScene'),
      import('./CharmSelectScene'),
      import('./DailySpinScene'),
      import('./EventsScene'),
      import('./ShellScene'),
      import('./NotePageScene'),
    ]);
    if (!game.scene.getScene('select')) game.scene.add('select', hero.HeroSelectScene, false);
    if (!game.scene.getScene('reveal')) game.scene.add('reveal', reveal.RivalRevealScene, false);
    if (!game.scene.getScene('powerups')) game.scene.add('powerups', power.PowerupSelectScene, false);
    if (!game.scene.getScene('game')) game.scene.add('game', play.GameScene, false);
    if (!game.scene.getScene('results')) game.scene.add('results', results.ResultsScene, false);
    if (!game.scene.getScene('hub')) game.scene.add('hub', hub.HubScene, false);
    if (!game.scene.getScene('road')) game.scene.add('road', road.RoadScene, false);
    if (!game.scene.getScene('streak')) game.scene.add('streak', streak.StreakScene, false);
    if (!game.scene.getScene('collection')) game.scene.add('collection', collection.CollectionScene, false);
    if (!game.scene.getScene('charms')) game.scene.add('charms', charms.CharmSelectScene, false);
    if (!game.scene.getScene('spin')) game.scene.add('spin', spin.DailySpinScene, false);
    if (!game.scene.getScene('events')) game.scene.add('events', events.EventsScene, false);
    if (!game.scene.getScene('shell')) game.scene.add('shell', shell.ShellScene, false);
    if (!game.scene.getScene('friends')) game.scene.add('friends', notes.FriendsScene, false);
    if (!game.scene.getScene('album')) game.scene.add('album', notes.AlbumScene, false);
  })();
  return loading;
}
